import React, { useState } from 'react';
import { HeroSection } from '../components/SalesLetter/HeroSection';
import { OpeningHook } from '../components/SalesLetter/OpeningHook';
import { PainAgitation } from '../components/SalesLetter/PainAgitation';
import { OldSolutions } from '../components/SalesLetter/OldSolutions';
import { UniqueMechanism } from '../components/SalesLetter/UniqueMechanism';
import { ProductReveal } from '../components/SalesLetter/ProductReveal';
import { AudienceSection } from '../components/SalesLetter/AudienceSection';
import { NotForEveryone } from '../components/SalesLetter/NotForEveryone';
import { BenefitsSection } from '../components/SalesLetter/BenefitsSection';
import { Testimonials } from '../components/SalesLetter/Testimonials';
import { BonusesSection } from '../components/SalesLetter/BonusesSection';
import { PackageSummary } from '../components/SalesLetter/PackageSummary';
import { OfferStack } from '../components/SalesLetter/OfferStack';
import { Visualization } from '../components/SalesLetter/Visualization';
import { Guarantee } from '../components/SalesLetter/Guarantee';
import { UrgencySection } from '../components/SalesLetter/UrgencySection';
import { CTASection } from '../components/SalesLetter/CTASection';
import { FAQSection } from '../components/SalesLetter/FAQSection';
import { BotanicalDivider } from '../components/SalesLetter/ui/BotanicalDivider';
import { X } from 'lucide-react';
function LegalPopup({
  title,
  onClose,
  children
}: {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}) {
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60" onClick={onClose} data-id="element-562">
      <div className="bg-[#FAF6F0] rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-563">
        <div className="sticky top-0 bg-[#FAF6F0] flex items-center justify-between p-5 border-b border-[#4A5D3A]/10" data-id="element-564">
          <h2 className="text-xl font-serif font-bold text-[#2D2A26]" data-id="element-565">
            {title}
          </h2>
          <button onClick={onClose} className="text-[#2D2A26]/60 hover:text-[#2D2A26] transition-colors" data-id="element-566">
            <X size={24} data-id="element-567" />
          </button>
        </div>
        <div className="p-6 text-[#2D2A26]/80 text-sm leading-relaxed space-y-4" data-id="element-568">
          {children}
        </div>
      </div>
    </div>;
}
export function SalesPage() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <main className="min-h-screen bg-[#FAF6F0] text-[#2D2A26] font-sans selection:bg-[#4A5D3A] selection:text-[#FAF6F0] overflow-x-hidden" data-id="element-569">
      <HeroSection data-id="element-570" />
      <BotanicalDivider data-id="element-571" />

      <OpeningHook data-id="element-572" />
      <BotanicalDivider data-id="element-573" />

      <PainAgitation data-id="element-574" />
      <BotanicalDivider data-id="element-575" />

      <OldSolutions data-id="element-576" />
      <BotanicalDivider data-id="element-577" />

      <UniqueMechanism data-id="element-578" />
      <BotanicalDivider data-id="element-579" />

      <ProductReveal data-id="element-580" />
      <BotanicalDivider data-id="element-581" />

      <AudienceSection data-id="element-582" />
      <BotanicalDivider data-id="element-583" />

      <NotForEveryone data-id="element-584" />
      <BotanicalDivider data-id="element-585" />

      <BenefitsSection data-id="element-586" />
      <BotanicalDivider data-id="element-587" />

      <Testimonials data-id="element-588" />
      <BotanicalDivider data-id="element-589" />

      <PackageSummary data-id="element-590" />
      <BotanicalDivider data-id="element-591" />

      <BonusesSection data-id="element-592" />
      <BotanicalDivider data-id="element-593" />

      <OfferStack data-id="element-594" />
      <BotanicalDivider data-id="element-595" />

      <Visualization data-id="element-596" />
      <BotanicalDivider data-id="element-597" />

      <Guarantee data-id="element-598" />
      <BotanicalDivider data-id="element-599" />

      <UrgencySection data-id="element-600" />

      <CTASection data-id="element-601" />
      <BotanicalDivider data-id="element-602" />

      <FAQSection data-id="element-603" />

      <footer className="py-6 text-center text-sm text-[#2D2A26]/40 border-t border-[#4A5D3A]/10 mt-8 space-y-3" data-id="element-604">
        <p data-id="element-605">
          © {new Date().getFullYear()} Rescate Herbáceo. Todos los derechos
          reservados.
        </p>
        <p className="text-xs" data-id="element-606">
          Este producto no sustituye el consejo médico profesional.
        </p>
        <div className="flex justify-center gap-4 text-xs" data-id="element-607">
          <button onClick={() => setShowTerms(true)} className="underline hover:text-[#4A5D3A] transition-colors cursor-pointer" data-id="element-608">
            Términos y Condiciones
          </button>
          <span data-id="element-609">·</span>
          <button onClick={() => setShowPrivacy(true)} className="underline hover:text-[#4A5D3A] transition-colors cursor-pointer" data-id="element-610">
            Política de Privacidad
          </button>
        </div>
      </footer>

      {showTerms && <LegalPopup title="Términos y Condiciones" onClose={() => setShowTerms(false)} data-id="element-611">
          <p data-id="element-612">
            <strong data-id="element-613">1. Aceptación de los Términos</strong>
          </p>
          <p data-id="element-614">
            Al adquirir el producto digital "Rescate Herbáceo S.O.S.", aceptas
            estos términos y condiciones en su totalidad. Si no estás de acuerdo
            con alguno de estos términos, te pedimos que no realices la compra.
          </p>

          <p data-id="element-615">
            <strong data-id="element-616">2. Naturaleza del Producto</strong>
          </p>
          <p data-id="element-617">
            Este es un producto digital informativo y educativo. No constituye
            consejo médico, diagnóstico ni tratamiento. Siempre consulta con un
            profesional de la salud antes de iniciar cualquier protocolo con
            plantas medicinales, especialmente si estás embarazada, en período
            de lactancia o tomas medicamentos.
          </p>

          <p data-id="element-618">
            <strong data-id="element-619">3. Entrega del Producto</strong>
          </p>
          <p data-id="element-620">
            El acceso al producto digital se entrega de forma inmediata tras la
            confirmación del pago a través de la plataforma Hotmart. Recibirás
            un correo electrónico con las instrucciones de acceso.
          </p>

          <p data-id="element-621">
            <strong data-id="element-622">4. Garantía de Devolución</strong>
          </p>
          <p data-id="element-623">
            Ofrecemos una garantía de satisfacción de 7 días calendario a partir
            de la fecha de compra. Si no estás satisfecha con el producto,
            puedes solicitar un reembolso completo enviando un correo
            electrónico a nuestro equipo de soporte. No se requiere
            justificación.
          </p>

          <p data-id="element-624">
            <strong data-id="element-625">5. Propiedad Intelectual</strong>
          </p>
          <p data-id="element-626">
            Todo el contenido del producto está protegido por derechos de autor.
            Queda prohibida la reproducción, distribución o reventa total o
            parcial del material sin autorización expresa por escrito.
          </p>

          <p data-id="element-627">
            <strong data-id="element-628">6. Limitación de Responsabilidad</strong>
          </p>
          <p data-id="element-629">
            Los resultados pueden variar de persona a persona. No garantizamos
            resultados específicos. El uso de las plantas medicinales descritas
            es responsabilidad exclusiva del usuario.
          </p>

          <p data-id="element-630">
            <strong data-id="element-631">7. Modificaciones</strong>
          </p>
          <p data-id="element-632">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Las modificaciones serán efectivas desde su publicación.
          </p>
        </LegalPopup>}

      {showPrivacy && <LegalPopup title="Política de Privacidad" onClose={() => setShowPrivacy(false)} data-id="element-633">
          <p data-id="element-634">
            <strong data-id="element-635">1. Información que Recopilamos</strong>
          </p>
          <p data-id="element-636">
            Al realizar tu compra, recopilamos la información necesaria para
            procesar tu pedido: nombre, dirección de correo electrónico y datos
            de pago (procesados de forma segura por Hotmart).
          </p>

          <p data-id="element-637">
            <strong data-id="element-638">2. Uso de la Información</strong>
          </p>
          <p data-id="element-639">
            Tu información personal se utiliza exclusivamente para: procesar tu
            compra y entregarte el producto digital, enviarte comunicaciones
            relacionadas con tu compra, y brindarte soporte al cliente si lo
            solicitas.
          </p>

          <p data-id="element-640">
            <strong data-id="element-641">3. Protección de Datos</strong>
          </p>
          <p data-id="element-642">
            No vendemos, alquilamos ni compartimos tu información personal con
            terceros con fines comerciales. Tus datos de pago son procesados de
            forma segura por Hotmart y nunca tenemos acceso a tu información
            financiera completa.
          </p>

          <p data-id="element-643">
            <strong data-id="element-644">4. Cookies y Tecnologías de Seguimiento</strong>
          </p>
          <p data-id="element-645">
            Nuestra página de ventas puede utilizar cookies y tecnologías
            similares para mejorar tu experiencia de navegación y analizar el
            tráfico del sitio.
          </p>

          <p data-id="element-646">
            <strong data-id="element-647">5. Comunicaciones por Email</strong>
          </p>
          <p data-id="element-648">
            Al realizar tu compra, podrás recibir correos electrónicos
            relacionados con el producto y contenido educativo. Puedes darte de
            baja en cualquier momento haciendo clic en el enlace de cancelación
            de suscripción incluido en cada correo.
          </p>

          <p data-id="element-649">
            <strong data-id="element-650">6. Tus Derechos</strong>
          </p>
          <p data-id="element-651">
            Tienes derecho a acceder, rectificar o eliminar tu información
            personal en cualquier momento. Para ejercer estos derechos, contacta
            a nuestro equipo de soporte por correo electrónico.
          </p>

          <p data-id="element-652">
            <strong data-id="element-653">7. Cambios en esta Política</strong>
          </p>
          <p data-id="element-654">
            Nos reservamos el derecho de actualizar esta política de privacidad.
            Te notificaremos de cualquier cambio significativo por correo
            electrónico.
          </p>
        </LegalPopup>}
    </main>;
}